import { Mail, Globe } from "lucide-react";
import freshmentLogo from "../../images/freshmentLogo1.png";
import { Link } from "react-router-dom";
import {
  Briefcase,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  ArrowRight,
  Search,
  ArrowUpRight,
  Clock,
  MapPin,
  Filter,
  Building2,
  X,
} from "lucide-react";

export default function Footer() {
  const menuLinks = [
    { label: "Home", href: "/" },
    { label: "Platform", href: "/about-edu" },
    { label: "About Us", href: "/about-us" },
    { label: "Support", href: "/support" },
  ];

  const legal = [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Use", href: "/terms" },
  ];

  return (
    <footer className="position-relative" style={styles.footer}>
      {/* Subtle background graphic line */}
      <div style={styles.topLine} />

      {/* Glow shadow */}
      <div style={styles.glow} />

      <div className="container py-5 position-relative" style={{ zIndex: 10 }}>
        {/* Main Grid split */}
        <div className="row gy-5 mb-5" style={{ marginBottom: "4rem" }}>
          {/* Logo & description (6 cols on lg) */}
          <div className="col-12 col-lg-6">
            <Link
              to="/"
              className="d-flex align-items-center text-decoration-none"
              style={{ gap: "0.625rem" }}
            >
              {/* <div style={styles.logoBox}>
                <Sparkles style={{ width: "20px", height: "20px", color: "#fff" }} />
              </div>
              <span className="font-display" style={styles.logoText}>EduConnectPro</span> */}
              <img
                src={freshmentLogo}
                alt="Freshment Logo"
                style={{ height: "40px", width: "auto", objectFit: "contain" }}
              />
            </Link>

            <p style={styles.description}>
              EduConnectPro is an AI-powered Placement Intelligence Platform
              that empowers universities with AI CoPilot, employer engagement,
              campus recruitment preparation, skill-gap intelligence, interview
              readiness, and placement analytics—bridging the gap between
              academic learning and industry hiring expectations.
            </p>

            <div
              className="d-flex align-items-center"
              style={{ gap: "0.75rem" }}
            >
              {/*  */}
              {/* <a
                href="https://twitter.com/freshmentjobs"
                target="_blank"
                style={styles.socialIcon}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a> */}
              {/*  */}
              {/* <a
                href="https://www.linkedin.com/in/tejal-s-9749641b4/"
                target="_blank"
                style={styles.socialIcon}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a> */}
              {/*  */}
              {/* <a href="#" style={styles.socialIcon}> */}
              {/* <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg> */}

              {/* </a> */}
              {/* <a
                href="mailto:contact@freshmentapp.com"
                style={styles.socialIcon}
              >
                <Mail style={{ width: "16px", height: "16px" }} />
              </a> */}
              <a
                href="https://twitter.com/freshmentjobs"
                className="text-gray-400 hover:text-blue-600 transition p-2 hover:bg-blue-50 rounded-full"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="https://www.linkedin.com/in/tejal-s-9749641b4/"
                target="_blank"
                rel="noreferrer noopener"
                className="text-gray-400 hover:text-blue-600 transition p-2 hover:bg-blue-50 rounded-full"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/freshmentofficial/"
                className="text-gray-400 hover:text-blue-600 transition p-2 hover:bg-blue-50 rounded-full"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Product links (3 cols on lg) */}
          <div className="col-12 col-md-6 col-lg-3 text-start">
            <h4 className="font-mono" style={styles.heading}>
              ABOUT EDUCONNECTPRO
            </h4>
            <div className="d-flex flex-column" style={{ gap: "0.75rem" }}>
              {menuLinks.map((item, idx) => (
                <Link key={idx} to={item.href} style={styles.link}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal / Contact links (3 cols on lg) */}
          <div className="col-12 col-md-6 col-lg-3 text-start">
            <h4 className="font-mono" style={styles.heading}>
              LEGAL
            </h4>
            <div className="d-flex flex-column" style={{ gap: "0.75rem" }}>
              {legal.map((item, idx) => (
                <Link key={idx} to={item.href} style={styles.link}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom copyright segment */}
        <div
          className="d-flex flex-column flex-md-row align-items-center justify-content-between"
          style={styles.bottomBar}
        >
          <div className="font-mono">
            © 2026 EduConnectPro SaaS. All rights reserved globally.
          </div>
          <div className="d-flex align-items-center" style={styles.statusPill}>
            <Globe
              style={{ width: "14px", height: "14px", color: "#FF5F14" }}
            />
            <span className="font-mono" style={styles.statusLabel}>
              Platform Status:
            </span>
            <span className="font-mono" style={{ color: "#94a3b8" }}>
              Fully Operational
            </span>
            <span style={styles.pulseDot} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes footerPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </footer>
  );
}

const styles = {
  footer: {
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "#fff",
    fontFamily: "sans-serif",
    overflow: "hidden",
  },
  topLine: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "1px",
    background:
      "linear-gradient(to right, transparent, rgba(255, 95, 20, 0.2), transparent)",
  },
  glow: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: "24rem",
    height: "24rem",
    backgroundColor: "rgba(255, 95, 20, 0.03)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  logoBox: {
    width: "40px",
    height: "40px",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 15px -3px rgba(255, 95, 20, 0.15)",
  },
  logoText: {
    fontSize: "1.125rem",
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-0.025em",
    textTransform: "uppercase",
  },
  description: {
    fontSize: "0.75rem",
    color: "#64748b",
    lineHeight: 1.625,
    maxWidth: "28rem",
    fontWeight: 500,
    margin: "1.5rem 0",
  },
  socialIcon: {
    padding: "0.625rem",
    borderRadius: "0.75rem",
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    color: "#64748b",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
  },
  heading: {
    fontSize: "11px",
    fontWeight: 800,
    fontFamily: "monospace",
    color: "#FF5F14",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    borderBottom: "1px solid rgba(254, 215, 170, 0.4)",
    paddingBottom: "0.5rem",
    display: "inline-block",
    marginBottom: "1.25rem",
  },
  link: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#475569",
    textDecoration: "none",
  },

  bottomBar: {
    borderTop: "1px solid rgba(226, 232, 240, 0.8)",
    paddingTop: "2rem",
    fontSize: "11px",
    color: "#94a3b8",
    fontFamily: "monospace",
    gap: "1rem",
  },
  statusPill: {
    gap: "0.5rem",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    border: "1px solid #e2e8f0",
    padding: "0.375rem 0.875rem",
    borderRadius: "9999px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
  },
  statusLabel: {
    fontWeight: 700,
    color: "#475569",
  },
  pulseDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#10b981",
    marginLeft: "0.25rem",
    animation: "footerPulse 2s ease-in-out infinite",
  },
};
